import { createSelector } from 'reselect';

import options from './options';

const { name } = options;

export const curNutrition = state => state.models[name].data;
export const curNutritions = state => state.models[name].list;
export const isNutritionLoading = state => state.models[name].loading;
